import Image from "next/image";
import { Card, CardHeader, CardBody } from "@material-tailwind/react";
import { useRouter } from "next/navigation";
import Link from "next/link";

export interface ProjectCardProps {
  id: number;
  title: string;
  description: string;
  content: string;
  thumbnail: string;
}

export function ProjectCard({
  id,
  title,
  description,
  content,
  thumbnail,
}: ProjectCardProps) {
  const router = useRouter();
  return (
    <Card color="transparent" shadow={false}>
      <CardHeader floated={false} className="mx-0 mt-0 mb-6">
        <Link href={`/blogs/${id}`}>
          <Image
            src={thumbnail}
            alt={`${title} - ภาพปกบทความ`}
            width={400}
            height={300}
            className="w-full h-auto object-cover rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
            priority={id <= 6} // 6 อันแรกโหลด priority
            loading={id <= 6 ? "eager" : "lazy"}
            placeholder="blur"
            blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q=="
            fetchPriority="high"
          />
        </Link>
      </CardHeader>
      <CardBody className="p-0">
        <Link
          href={`/blogs/${id}`}
          className="text-blue-gray-900 transition-colors hover:text-gray-800"
        >
          <div className="mb-2 line-clamp-2 font-bold text-[18px]">{title}</div>
        </Link>
        <div className="mb-6 font-normal !text-gray-500 line-clamp-1 md:line-clamp-3">
          {description}
        </div>
        {/* <Button
          color="gray"
          size="sm"
          className="bg-[#188F46] font-noto"
          onClick={() => router.push(`/blogs/${id}`)}
        >
          รายละเอียดเพิ่มเติม
        </Button> */}
      </CardBody>
    </Card>
  );
}

export default ProjectCard;
